export default __webpack_public_path__ + "static/media/MarieLovelace.a0297697.png";